// The ordered sections of the email-campaign editor's left column. Shared by the
// editor (which tags each card with the id) and the SectionNav dot rail (which
// scroll-spies + scrolls to them). One source of truth so they can't drift.
export interface CampaignSection {
  id: string
  label: string
}

export const CAMPAIGN_SECTIONS: CampaignSection[] = [
  { id: "campaign-section-from", label: "From" },
  { id: "campaign-section-to", label: "To" },
  { id: "campaign-section-body", label: "Body" },
  { id: "campaign-section-attachments", label: "Attachments" },
]

// Each section card sets this so a programmatic scroll lands BELOW both sticky
// bars (the 56px app header + the campaign FormHeader) instead of hiding the
// section title under them.
export const SECTION_SCROLL_MARGIN_TOP = 116
